import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Button from "../components/Reusable/Button";
const SomethingWentWrong = () => {
  const handleNavigate = () => {
    window.localStorage.removeItem("token");
    window.location.replace("/auth-login");
  };
  return (
    <div className={tw`flex h-[100vh] overflow-y-auto `}>
      <div className={tw`h-full w-full`}>
        <div
          className={tw`bg-primary-light w-full h-36 text-primary text-2xl flex items-center justify-center font-bold`}
        >
          Something went wrong !
        </div>
        <div className={tw`mx-16`}>
          <p>For any inquries or assistance, please contact us at:</p>
          <p>Phone no:+977-</p>
          <p>Email:Support@careinfo.com</p>
          <div className={tw`w-full flex justify-end `}>
            <div className={tw`w-32`}>
              <Button
                label={"Back to Login"}
                onClick={() => handleNavigate()}
                type={"button"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SomethingWentWrong;
